import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import cn from 'classnames';
import Button from '../../common/Button/Button';
import styles from './FormSMS.scss';
import dotIcon from './dot.svg';
import tracker from '../../../services/tracker';
import { withTranslation } from 'react-i18next';

const DELAY_SMS = 30;

const Dot = () => <img alt="mask" src={dotIcon} />;
// eslint-disable-next-line react/no-array-index-key
const getMask = (length = 5) => new Array(length).fill('').map((_, index) => <Dot key={length - index} />);

class FormSMS extends Component {
  constructor(props) {
    super(props);

    this.state = {
      code: '',
      mask: getMask(),
      remainingTime: 0
    };

    this.timerRef = null;

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleButtonClick = this.handleButtonClick.bind(this);
    this.handleResendClick = this.handleResendClick.bind(this);
  }

  componentDidMount() {
    this.handleStartTimer();
  }

  componentWillUnmount() {
    if (this.timerRef) clearInterval(this.timerRef);
  }

  handleStartTimer() {
    this.setState({ remainingTime: DELAY_SMS });
    this.timerRef = setInterval(() => {
      if (this.state.remainingTime === 0) {
        clearInterval(this.timerRef);
        this.timerRef = null;
      } else {
        this.setState(prev => ({ remainingTime: prev.remainingTime - 1 }));
      }
    }, 1000);
  }

  handleInputChange(event) {
    const { target } = event;

    const codeArray = target.value.split('').map(letter => <span>{letter}</span>);
    const newMask = [...codeArray, ...getMask(5 - codeArray.length)];

    this.setState({ code: target.value, mask: newMask });
  }

  handleButtonClick(e) {
    const { smsFormSending, number } = this.props;
    const { code } = this.state;
    // tracker.sendEvent('Web_Sms_Code_Entered');
    smsFormSending(number, code);
    e.preventDefault();
  }

  handleResendClick() {
    const { numberFormSending, number } = this.props;
    this.setState({ code: '', mask: getMask() });
    numberFormSending(number.replace(/\s+/g, ''));
    this.handleStartTimer();
  }

  render() {
    const { isLoading, smsError, t } = this.props;
    const { code, remainingTime } = this.state;

    const isButtonDisabled = code.length <= 4;

    return (
      <div className={styles.FormInner}>
        <div className={styles.Title}>
          {t('components.login.formSMS.title')}
        </div>
        <div className={cn(styles.Description, smsError && styles.LabelErr)}>{smsError ? t('components.login.formSMS.smsError') : t('components.login.formSMS.sms')}</div>
        <form role="form">
          {isLoading
              ? (
                <div className={styles.LoaderWrapper}>
                  <div className={styles.Loader} />
                </div>
              )
              : (
                <div className={styles.InputWrap}>
                  <div className={cn(styles.Input, smsError && styles.InputError)}>
                    <div className={styles.Mask}>
                      {this.state.mask}
                    </div>
                    <input
                      step="10"
                      maxLength="5"
                      ref={ref => {
                        if (ref) ref.focus();
                      }}
                      value={code}
                      onChange={this.handleInputChange}
                    />
                  </div>
                  {remainingTime > 0
                    ? (
                      <div className={styles.AwaitSMS}>
                        {t('components.login.formSMS.remainingTime', { remainingTime })}
                      </div>
                    )
                    : (
                      <Button className={styles.Blue} onClick={this.handleResendClick}>
                        {t('components.login.formSMS.resend')}
                      </Button>
                    )}
                  <Button type="submit" className={styles.SubmitButton} disabled={isLoading || isButtonDisabled} onClick={this.handleButtonClick}>
                    {t('components.login.formSMS.submit')}
                  </Button>
                </div>
              )}
        </form>
      </div>
    );
  }
}

export default withTranslation()(withRouter(FormSMS));



// WEBPACK FOOTER //
// ./src/components/Login/FormSMS/FormSMS.js